import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseLarge = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M14.9512 4.10547C15.3027 3.72461 15.918 3.72461 16.2695 4.10547C16.6504 4.45703 16.6504 5.07227 16.2695 5.42383L11.3184 10.375L16.2695 15.3555C16.6504 15.707 16.6504 16.3223 16.2695 16.6738C15.918 17.0547 15.3027 17.0547 14.9512 16.6738L10 11.7227L5.01953 16.6738C4.66797 17.0547 4.05273 17.0547 3.70117 16.6738C3.32031 16.3223 3.32031 15.707 3.70117 15.3555L8.65234 10.375L3.70117 5.42383C3.32031 5.07227 3.32031 4.45703 3.70117 4.10547C4.05273 3.72461 4.66797 3.72461 5.01953 4.10547L10 9.05664L14.9512 4.10547Z"
	})
});
const ForwardRef = forwardRef(SvgCloseLarge);
export default ForwardRef;
